// extracted by mini-css-extract-plugin
export default {"pagination":"paginateCard_pagination__7hRJ8","active":"paginateCard_active__vV59D"};